var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ag-grid__overlay-form-box" }, [
    _c("div", {
      directives: [
        {
          name: "t",
          rawName: "v-t",
          value: "ANNOTATE_CALLS",
          expression: "'ANNOTATE_CALLS'"
        }
      ],
      staticClass: "ag-grid__overlay-form-box-title"
    }),
    _vm._v(" "),
    _c("div", { staticClass: "p-15" }, [
      !_vm.callsReviewed
        ? _c(
            "div",
            { staticClass: "col-md-offset-3" },
            [
              _c("BulkCallDetails", {
                key: _vm.bulkCallReviewKey,
                attrs: { "selected-calls": _vm.selectedCalls },
                on: { unselectCallOnBulkAction: _vm.unselectCallOnBulkAction }
              }),
              _vm._v(" "),
              _c("div", [
                _c("button", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "CONTINUE",
                      expression: "'CONTINUE'"
                    }
                  ],
                  staticClass: "btn btn-primary btn-sm m-t-15",
                  on: {
                    click: function($event) {
                      _vm.callsReviewed = true
                    }
                  }
                }),
                _vm._v(" "),
                _c("button", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "CANCEL",
                      expression: "'CANCEL'"
                    }
                  ],
                  staticClass: "btn btn-danger btn-sm m-t-15 m-l-10",
                  on: { click: _vm.hideBulkForm }
                })
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.callsReviewed
        ? _c("div", [
            _c(
              "span",
              {
                staticClass: "clickable",
                on: {
                  click: function($event) {
                    _vm.callsReviewed = false
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-chevron-left m-r-5" }),
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("REVIEW_CALLS")) + "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "container-fluid" },
              [
                _c("TagAnnotateForm", {
                  attrs: {
                    "show-loader": _vm.showLoader,
                    "recent-tags": _vm.recentTags
                  },
                  on: {
                    closeForm: _vm.hideBulkForm,
                    annotateCallSubmit: _vm.annotateCalls
                  }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }